<main>
  <app-articles-sidenav
    [currentSearch]="currentSearch"
    [worldCountries] = "worldCountries"
    (searchByCountry)="searchByCountry($event)"
    (searchByCategory)="searchByCategory($event)">
  </app-articles-sidenav>
  <section class="articles">
    <header>
      <section class="articles__info">
        <mat-icon>info</mat-icon>
        <span>Curated COVID-19 literature, updated daily. Source:
          <a mat-button color="primary"
          href="https://www.ncbi.nlm.nih.gov/research/coronavirus/"
          target="_blank">
          LitCovid by NCBI/NLM
        </a>
        </span>
      </section>
      <form [formGroup]="searchForm"
      (ngSubmit)="doSearch(filterBy.name)">
      <mat-form-field class="articles__filters"
        appearance="outline">
        <mat-label>Search by</mat-label>
        <mat-select (selectionChange)="selectedOption($event)"
           [value]="filterBy">
          <mat-option *ngFor="let filter of filters"
            [value]="filter">
            {{filter.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="articles__query"
        appearance="outline">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput formControlName="query"
          appDynamicPlaceholder
          placeholder="Ex: Dunjin, Chen"
          autocomplete="off"
          [text]="text">
          <mat-icon *ngIf="searchForm.value.query"
           (click)="clearQuery(searchForm)"
            matSuffix>clear</mat-icon>
      </mat-form-field>
      <button class="articles__query__button"
        mat-flat-button
        color="primary"
        (click)="doSearch(filterBy.name)">Search</button>
     </form>
     <section class="articles__query__pagination">
       <strong>{{currentSearch}}</strong>
      <mat-paginator [length]="total"
        [pageIndex]="page"
        [pageSize]="itemsPerPage"
        (page)="moreData($event)">
      </mat-paginator>
     </section>
    </header>
    <mat-progress-bar
      *ngIf="loading"
      class="example-margin"
      [color]="'primary'"
      [mode]="'query'">
    </mat-progress-bar>
    <app-references [references]=references>
    </app-references>
  </section>
</main>
